/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/vatPeriodSelect.scss';

import {AwesomeIcon} from '@dvrd/dvr-controls';
import classNames from 'classnames';
import React, {MouseEventHandler} from 'react';
import {VATPeriod, VatPeriod} from "../../../util/interfaces";

interface Props {
    onClickPeriod: (period: VatPeriod) => MouseEventHandler;
    onClickPeriodType: (periodType: VATPeriod) => MouseEventHandler;
    onPrevPeriod: MouseEventHandler;
    onNextPeriod: MouseEventHandler;
    periods: VatPeriod[];
    periodType: VATPeriod;
    selectedPeriod: string;
    loading: boolean;
}

export default function VatPeriodSelect(props: Props) {
    const {
        onNextPeriod, onPrevPeriod, periods, onClickPeriod, periodType, onClickPeriodType, selectedPeriod, loading
    } = props;

    function renderPeriodTypes() {
        return (
            <div className='period-types'>
                {renderPeriodType('Maanden', VATPeriod.MONTH)}
                {renderPeriodType('Kwartalen', VATPeriod.QUARTER)}
                {renderPeriodType('Jaren', VATPeriod.YEAR)}
                {renderPeriodType('Aangepast...', VATPeriod.CUSTOM, false)}
            </div>
        )
    }

    function renderPeriodType(label: string, type: VATPeriod, allowHighlight: boolean = true) {
        return (
            <div className={classNames('period-type', (type === periodType && allowHighlight) && 'active')}
                 onClick={onClickPeriodType(type)}>
                <label className='period-type-label'>{label}</label>
            </div>
        )
    }

    function renderPeriods() {
        const columns = `2rem repeat(${periods.length}, 1fr) 2rem`
        return (
            <div className='vat-periods' style={{gridTemplateColumns: columns}}>
                <div className='nav-btn prev' onClick={onPrevPeriod}>
                    <AwesomeIcon name='chevron-left' className='nav-icon'/>
                </div>
                {periods.map(renderPeriod)}
                <div className='nav-btn' onClick={onNextPeriod}>
                    <AwesomeIcon name='chevron-right' className='nav-icon'/>
                </div>
            </div>
        )
    }

    function renderPeriod(period: VatPeriod, index: number) {
        const label = period.label.replace(/( \d+)$/, '');
        let fullLabel = label;
        if (periodType !== VATPeriod.YEAR) fullLabel += ` ${period.start.year()}`;
        const isSelected = fullLabel === selectedPeriod;
        return (
            <div
                className={classNames('period-btn', isSelected && 'active', loading && 'disabled')}
                key={index} onClick={onClickPeriod(period)}>
                <label className='period-label'>{label}</label>
                {periodType !== VATPeriod.YEAR && <label className='year-label'>{period.start.year()}</label>}
            </div>
        )
    }

    return (
        <div className='vat-period-select'>
            {renderPeriodTypes()}
            {periodType !== VATPeriod.CUSTOM && renderPeriods()}
        </div>
    )
}